<template>
  <div>
    <!-- 提交记录 -->
    <tool
      :level="level"
      @search="onSearch"
      @reset="onReset"
    />
    <div class="radios clf">
      <a-radio-group
        v-model="status"
        @change="switchStatus"
      >
        <template v-for="item in statusSelect">
          <a-radio-button
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </a-radio-button>
        </template>
      </a-radio-group>
      <a
        href="javascript:;"
        class="del-sub-btn"
        :class="{'dis-del-sub-btn': selectedRowKeys.length <= 0}"
        @click="delHandler"
      >
        {{ $t('message["982"]') }}
      </a>
      <router-link
        :to="{name: 'smartIntercept'}"
        class="intercept_entrance"
      >
        <!-- {{ $t('message["584"]') }}（{{ interceptCount }}条） -->
        {{ intrptNumber }}
      </router-link>
    </div>
    <div class="record_main">
      <a-table
        :columns="formColumns"
        :data-source="dataSource"
        :pagination="false"
        :loading="loading"
        :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :custom-row="toDetail"
        @change="onChange"
      >
        <!-- <p
          slot="status"
          slot-scope="text"
          style="width: 80px;"
        >
          <status-tag :status="text" />
        </p> -->
        <p
          slot="contact"
          slot-scope="text, record, index"
          style="width: 100px;"
        >
          <other-tooltip
            col-key="contact"
            :text="text || '--'"
            :index="index"
            :columns="formColumns"
          />
        </p>
        <p
          slot="form_name"
          slot-scope="text, record, index"
          class="form_belong"
        >
          <other-tooltip
            col-key="form_name"
            :text="text || '--'"
            :index="index"
            :columns="formColumns"
          />
        </p>
        <div
          slot="username"
          slot-scope="text, record, index"
          style="max-width: 140px;min-width: 60px;"
        >
          <div class="table_time">
            <p :class="['time_date', formatDeveloper(record) === '--' ? 'font_normal' : '']">
              <other-tooltip
                col-key="username"
                :text="text || '--'"
                :index="index"
                :columns="formColumns"
              />
            </p>
            <p
              v-if="formatDeveloper(record) !== '--'"
              class="time_division developer"
            >
              {{ formatDeveloper(record) }}
            </p>
          </div>
        </div>
        <p
          slot="url"
          slot-scope="text, record, index"
          class="form_url"
          @click.stop="toHref(text)"
        >
          <other-tooltip
            col-key="from_url"
            :text="text || '--'"
            :index="index"
            :columns="formColumns"
          />
        </p>
        <div
          slot="ip"
          slot-scope="text, record"
          style=""
        >
          <div class="table_time">
            <p>
              {{ text }}
            </p>
            <p
              v-if="record.from_ip_city"
              class="time_division developer"
            >
              {{ record.from_ip_city }}
            </p>
          </div>
        </div>
        <div
          slot="addtime"
          slot-scope="text"
          style="width: 100px;"
        >
          <div class="table_time">
            <p class="time_date">
              {{ formatUpTime(text, 1) }}
            </p>
            <p
              v-if="text"
              class="time_division"
            >
              {{ formatUpTime(text, 2) }}
            </p>
          </div>
        </div>
      </a-table>
      <pagination
        v-if="totalCount > 0"
        ref="pagination"
        :pagination="pagination"
        @change="handlePage"
      />
    </div>
    <!-- 查看详情 -->
    <template>
      <info-detail
        :id="detailID"
        :init="init"
        :visible.sync="showDetailVisible"
        @entry="toEntry"
        @deal="toDeal"
      />
    </template>
    <no-deal-reason-dialog
      :id="detailID"
      ref="reasonDialog"
      @getData="deal"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import Tool from './components/SubmitTool'
import Pagination from '@/components/pc/Pagination'
import infoDetail from './components/Detail'
import NoDealReasonDialog from './components/NoDealReasonDialog'
import { mapState, mapActions, mapMutations } from 'vuex'
import { formatUpTime, formatDeveloper, formatField } from './common'
import { getLang } from '@/lib/storage'
import OtherTooltip from './components/OtherTooltip'

export default {
  components: {
    Tool,
    Pagination,
    infoDetail,
    NoDealReasonDialog,
    OtherTooltip
  },
  props: {
    // 权限
    level: {
      type: Number,
      default: 3
    },
    permissions: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      // 详情抽屉显示
      showDetailVisible: false,
      // 详情ID
      detailID: 0,
      query: {},
      status: 0,
      selectedRowKeys: []
    }
  },
  computed: {
    ...mapState('smart/submit', [
      'formColumns',
      'recordList',
      'totalCount',
      'pagination',
      'loading',
      'interceptCount',
      'queryParams',
      'subQuery',
      'statusSelect'
    ]),
    dataSource () {
      return this.recordList.map(item => {
        item.key = item.id
        return item
      })
    },
    // 权限控制表格显示
    levelFormColumns () {
      let aColums = [].concat(...this.formColumns)
      aColums.forEach((item, index) => {
        if (item.key === 'username' && this.level === 0) {
          aColums.splice(index, 1)
        }
      })
      return aColums
    },
    intrptNumber () {
      const lang = this.getLang()
      if (lang === 'zh') {
        return `拦截记录（${this.interceptCount}条）`
      } else {
        return `（${this.interceptCount}）blocked`
      }
    },
    delTips () {
      return this.$t('message["967"]').split('|')
    }
  },
  destroyed () {
    // 初始化变量
    this.SET_PAGINATION({ key: 'currentPage', value: 1 })
    this.SET_SUB_QUERY({})
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions('smart/submit', ['fetchDataList', 'fetchRecordDetail', 'setInfoDeal', 'delRecords']),
    ...mapMutations('smart/submit', ['SET_PAGINATION', 'SET_SUB_QUERY']),
    formatDeveloper,
    formatField,
    formatUpTime,
    getLang,
    // 请求列表数据
    async fetchList (obj = {}) {
      let params = {
        tab: 'subRecord',
        page: this.pagination.currentPage,
        limit: this.pagination.pageSizesType[this.pagination.pageSize],
        ...obj
      }
      await this.fetchDataList(params)
      this.$router.push({ query: params })
    },
    // 打开【查看详情】
    toDetail (record, index) {
      const _this = this
      return {
        on: {
          click: () => {
            const { id } = record
            _this.$set(_this._data, 'detailID', id)
            _this.fetchDetail({ id })
            _this.showDetailVisible = true
          }
        }
      }
    },
    // 触发排序
    onChange (pagination, filters, sorter) {
      let params = Object.assign({}, { sortkey: '' }, { sorttype: 0 })
      if (sorter.order) {
        const { order } = sorter
        let sort = 0
        const orderTable = { 'ascend': 1, 'descend': 2 }
        sort = orderTable[order]
        params = Object.assign(params, { sortkey: sorter.columnKey }, { sorttype: sort })
      }
      this.fetchList({
        ...this.$route.query,
        page: pagination.currentPage,
        limit: pagination.pageSize,
        ...params
      })
    },
    // 重置
    resetFetchList (info = {}) {
      const { currentPage, pageSize } = info
      // 请求数据
      this.fetchList({
        ...this.$route.query,
        page: currentPage,
        limit: this.pagination.pageSizesType[pageSize]
      })
    },
    // 页码改变触发
    handlePage (pagination) {
      const { currentPage, pageSize } = pagination
      this.SET_PAGINATION({ key: 'currentPage', value: currentPage })
      this.resetFetchList({ currentPage, pageSize })
      this.selectedRowKeys = []
    },
    // 获取记录详情
    async fetchDetail (params) {
      await this.fetchRecordDetail(params)
    },
    // 搜索
    onSearch (result) {
      if (Object.keys(result).length > 0) {
        // 有查询条件
        this.SET_PAGINATION({ key: 'currentPage', value: 1 })
      }
      let params = Object.assign(result, { status: this.status })
      this.fetchList(params)
      this.clearSelectedRowKeys()
    },
    // 重置
    onReset () {
      let params = Object.assign({}, { status: this.status })
      this.$router.push({ query: { tab: 'subRecord' } })
      this.fetchList(params)
      this.clearSelectedRowKeys()
    },
    clearSelectedRowKeys () {
      this.selectedRowKeys = []
    },
    init () {
      this.fetchList(Object.assign({}, this.subQuery, { status: this.status }))
    },
    // 跳转到录入详情页
    toEntry (params) {
      this.$router.push({ name: 'InqueryCreate', query: params })
    },
    // 查看详情【不处理】
    async dealInfo (params) {
      const _this = this
      const chain = await this.setInfoDeal(params)
      let obj = Object.assign({}, this.queryParams, { status: this.status })
      chain.onSuccess(res => {
        // 此时请求需要携带查询内的条件
        _this.fetchList(obj)
        _this.fetchDetail(params)
        this.$refs.reasonDialog.changeVisible(false)
        this.showDetailVisible = false
        _this.$message.success(this.$t('message["1012"]'))
      })
        .fetch()
    },
    toDeal (params) {
      // this.dealInfo(params)
      this.$refs.reasonDialog.changeVisible(true)
    },
    deal (params) {
      this.dealInfo(params)
    },
    // 点击【来源地址】跳转
    toHref (url) {
      if (url || url !== '') {
        window.open(url)
      }
    },
    // 切换状态
    switchStatus (e) {
      const { value } = e.target
      this.selectedRowKeys = []
      this.fetchList({
        ...this.$route.query,
        status: value
      })
    },
    onSelectChange (value) {
      this.selectedRowKeys = value
    },
    delHandler () {
      // debugger
      const that = this
      const { selectedRowKeys } = this
      const len = selectedRowKeys.length
      // this.delRec()
      if (len > 0) {
        this.$confirm({
          iconType: 'info-circle',
          title: this.$t('message["976"]'),
          content: <div>{this.delTips[0]}<span class="confitm_warning">{this.delTips[1]}</span>{this.delTips[2]}</div>,
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          closable: true,
          onOk: () => {
            that.delRec()
          }
        })
      }
    },
    async delRec () {
      const chain = await this.delRecords({ ids: this.selectedRowKeys })
      // console.log(this.selectedRowKeys)
      chain.onSuccess(raw => {
        this.$message.success(this.$t('message["965"]') + '！')
        this.selectedRowKeys = []
        this.init()
      })
        .fetch()
    }
  }
}
</script>

<style scoped lang="scss">
.intercept_entrance {
  float: right;
  // display: inline-block;
  padding: 4px 12px;
  color: $danger-color;
  border-radius: 4px;
  border: 1px solid $danger-color;
  line-height: 24px;
  // margin: 0 24px;
}
.intercept_entrance:hover {
  cursor: pointer;
}
.table_time {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .time_division,
  .time_date {
    font-size: 12px;
    height: 16px;
  }
  .time_division {
    color: #999;
  }
}
.form_url {
  max-width: 224px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: $primary-color;
}
.form_url:hover {
  cursor: pointer;
}
.record_main::v-deep {
  margin: 24px 0;
   .ant-table-row:hover {
    cursor: pointer;
  }
  .ant-checkbox-wrapper {
    margin-bottom: 0;
  }
}
.form_belong {
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_time {
  .time_division,
  .time_date {
    font-size: 12px;
    line-height: 16px;
  }
  .developer {
    margin-top: 4px;
  }
  .time_division {
    color: $gray;
  }
  .font_normal {
    font-size: 14px;
    color: #333;
  }
}
.radios {
  border-top: 1px solid #ebebeb;
  padding-top: 15px;
  ::v-deep .ant-radio-button-wrapper {
    width: 130px;
    text-align: center;
  }
}
.del-sub-btn {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  color: #fff;
  background: #f57676;
  border-radius: 4px;
  padding: 0 12px;
  margin-left: 48px;
}
.dis-del-sub-btn {
  opacity: 0.6;
  filter: alpha(opacity = 60);
  cursor: no-drop;
}
.confitm_warning {
  color: #f57676;
}
</style>
